import styled from "styled-components";
import { Box } from "theme-ui";

export const PaymentTrackerContainer = styled(Box)`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
  width: 100%;
  height: 57px;
  padding-bottom: 15px;
`;

export const StageWrapper = styled(Box)<{ $isActive?: boolean; $isCompleted?: boolean; $isLate?: boolean; $align?: 'flex-start' | 'center' | 'flex-end' }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $align }) => $align || 'center'};
  position: relative;
  z-index: 2;
  flex: 1;
`;

export const StageLabel = styled.p<{ $isActive?: boolean; $isCompleted?: boolean; $isLate?: boolean }>`
  font-family: 'Poppins', sans-serif;
  font-weight: ${({ $isActive, $isCompleted, $isLate }) =>
    $isActive || $isCompleted || $isLate ? 600 : 500};
  font-size: 14px;
  line-height: 10px;
  text-align: center;
  margin: 0;
  margin-bottom: 8px;
  color: ${({ $isActive, $isCompleted, $isLate }) => 
    $isLate ? '#D32F2F' : ($isActive || $isCompleted ? '#667E4E' : '#818181')};
  white-space: nowrap;
`;

export const StageDate = styled.p<{ $isActive?: boolean; $isCompleted?: boolean; $isLate?: boolean }>`
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 10px;
  text-align: center;
  margin: 0;
  margin-bottom: 12px;
  color: ${({ $isActive, $isCompleted }) => 
    $isActive || $isCompleted ? '#667E4E' : '#818181'};
  white-space: nowrap;
`;

export const ProgressBarContainer = styled(Box)`
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  height: 1px;
  display: flex;
  align-items: center;
  z-index: 1;
`;

export const ProgressLine = styled(Box)<{ $isCompleted?: boolean }>`
  flex: 1;
  height: 4px;
  background-color: ${({ $isCompleted }) => ($isCompleted ? '#667E4E' : '#EBEBEB')};
  transition: background-color 0.3s ease;
`;

export const StageIndicator = styled(Box)<{ $isActive?: boolean; $isCompleted?: boolean }>`
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: ${({ $isActive, $isCompleted }) =>
    $isActive || $isCompleted ? '#667E4E' : '#EBEBEB'};
  border: 2px solid ${({ $isActive, $isCompleted }) =>
    $isActive || $isCompleted ? '#667E4E' : '#EBEBEB'};
  transition: all 0.3s ease;
  flex-shrink: 0;
  z-index: 2;
`;

export const InfoIcon = styled.div`
  width: 10px;
  height: 10px;
  margin-left: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: help;
`;

export const LabelWithIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const WarningIconWrap = styled.div`
  width: 15px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  z-index: 1;
  position: relative;
  
  svg {
    position: absolute;
    z-index: 3;
    stroke: white;
    stroke-width: 6px;
    paint-order: stroke fill;
  }
`;

export const LateLabel = styled.span`
  color: #D32F2F;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 12px;
  margin-left: 4px;
`;
